export function accinit() {
    const accBtn = document.querySelectorAll('.news__innerRowsRowTtl')

    accBtn.forEach((accBtnList) => {
        const ans = accBtnList.nextElementSibling
        let height = ans.clientHeight / window.innerWidth * 100;
        ans.style.height = "0vw"

        accBtnList.addEventListener('click', () => {
            const accBtnParent = accBtnList.parentNode
            accBtnParent.classList.toggle("is-on")
            if (accBtnParent.classList.contains("is-on")) {
                ans.style.height = `${height}vw`
            } else {
                ans.style.height = "0vw"
            }
            setTimeout(() => {
                try {
                    window.globalLocoUpdate()
                } catch {

                }
            }, 400)
        });
    });
}